import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const TestCreateGraphic = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} inheritViewBox={true}>
      <svg
        width="349"
        height="237"
        viewBox="0 0 349 237"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4461_14289)">
          <rect width="349" height="237" fill="#F5F7F7" />
          <g filter="url(#filter0_dd_4461_14289)">
            <rect
              x="45.1499"
              y="46.2"
              width="126"
              height="144"
              rx="7.2"
              fill="#DFE3E3"
            />
            <g clipPath="url(#clip1_4461_14289)">
              <rect
                x="41.5498"
                y="42.6"
                width="126"
                height="144"
                rx="7.2"
                fill="white"
              />
              <path
                d="M41.5498 49.8C41.5498 45.8235 44.7734 42.6 48.7498 42.6H160.35C164.326 42.6 167.55 45.8235 167.55 49.8V57H41.5498V49.8Z"
                fill="#EFF1F1"
              />
              <circle cx="50.55" cy="49.8" r="1.8" fill="#C9CDCD" />
              <circle cx="57.7497" cy="49.8" r="1.8" fill="#C9CDCD" />
              <circle cx="64.9499" cy="49.8" r="1.8" fill="#C9CDCD" />
              <rect
                x="50.5498"
                y="64.2"
                width="108"
                height="55.8"
                rx="2.7"
                fill="#EFF1F1"
              />
              <rect
                x="99.1499"
                y="68.7"
                width="10.8"
                height="12.6"
                rx="1.8"
                fill="#C9CDCD"
              />
              <rect
                x="91.0498"
                y="79.5"
                width="27"
                height="34.2"
                rx="3.6"
                fill="#C9CDCD"
              />
              <rect
                x="50.5498"
                y="127.2"
                width="61.2"
                height="5.4"
                rx="2.7"
                fill="#C9CDCD"
              />
              <path
                d="M54.4617 154.027V141.754H55.248V154.027H54.4617ZM57.108 145.436C57.0505 144.95 56.8172 144.573 56.4081 144.305C55.999 144.036 55.4972 143.902 54.9028 143.902C54.4681 143.902 54.0878 143.973 53.7618 144.113C53.439 144.254 53.1865 144.447 53.0044 144.693C52.8254 144.939 52.7359 145.219 52.7359 145.532C52.7359 145.794 52.7982 146.02 52.9229 146.208C53.0507 146.393 53.2137 146.549 53.4118 146.673C53.61 146.795 53.8177 146.895 54.0351 146.975C54.2524 147.052 54.4521 147.114 54.6343 147.162L55.6315 147.431C55.8872 147.498 56.1716 147.59 56.4848 147.709C56.8012 147.827 57.1032 147.988 57.3909 148.193C57.6817 148.394 57.9214 148.653 58.11 148.969C58.2986 149.286 58.3928 149.674 58.3928 150.134C58.3928 150.665 58.2538 151.144 57.9758 151.573C57.7009 152.001 57.2982 152.341 56.7677 152.594C56.2403 152.846 55.5995 152.973 54.8453 152.973C54.1421 152.973 53.5333 152.859 53.0187 152.632C52.5074 152.405 52.1047 152.089 51.8106 151.683C51.5198 151.277 51.3552 150.806 51.3169 150.269H52.5441C52.5761 150.639 52.7007 150.946 52.9181 151.189C53.1386 151.429 53.4166 151.608 53.7522 151.726C54.091 151.841 54.4553 151.899 54.8453 151.899C55.2991 151.899 55.7066 151.825 56.0677 151.678C56.4289 151.528 56.7149 151.32 56.9259 151.055C57.1368 150.786 57.2423 150.473 57.2423 150.115C57.2423 149.789 57.1512 149.524 56.969 149.319C56.7868 149.115 56.5471 148.949 56.2499 148.821C55.9527 148.693 55.6315 148.581 55.2863 148.485L54.0782 148.14C53.3112 147.92 52.7039 147.605 52.2565 147.196C51.809 146.787 51.5853 146.251 51.5853 145.59C51.5853 145.04 51.7339 144.561 52.0312 144.151C52.3316 143.739 52.7343 143.42 53.2393 143.193C53.7474 142.963 54.3147 142.848 54.9411 142.848C55.574 142.848 56.1365 142.961 56.6286 143.188C57.1208 143.412 57.5107 143.718 57.7984 144.108C58.0892 144.498 58.2426 144.941 58.2586 145.436H57.108ZM60.175 152.8V151.937L63.4158 148.389C63.7961 147.974 64.1093 147.613 64.3554 147.306C64.6015 146.996 64.7837 146.705 64.9019 146.433C65.0234 146.159 65.0841 145.871 65.0841 145.571C65.0841 145.225 65.001 144.927 64.8348 144.674C64.6718 144.422 64.4481 144.227 64.1637 144.089C63.8792 143.952 63.5596 143.883 63.2049 143.883C62.8277 143.883 62.4985 143.961 62.2173 144.118C61.9392 144.271 61.7235 144.487 61.5701 144.765C61.4199 145.043 61.3448 145.369 61.3448 145.743H60.2134C60.2134 145.168 60.346 144.663 60.6113 144.228C60.8766 143.794 61.2377 143.455 61.6947 143.212C62.155 142.969 62.6711 142.848 63.2432 142.848C63.8185 142.848 64.3283 142.969 64.7725 143.212C65.2168 143.455 65.5651 143.782 65.8176 144.195C66.0701 144.607 66.1963 145.066 66.1963 145.571C66.1963 145.932 66.1308 146.285 65.9998 146.63C65.8719 146.972 65.6482 147.354 65.3286 147.776C65.0122 148.194 64.5728 148.706 64.0103 149.31L61.805 151.669V151.745H66.3689V152.8H60.175ZM71.4746 142.848C71.8773 142.851 72.28 142.927 72.6827 143.078C73.0854 143.228 73.4529 143.477 73.7853 143.825C74.1177 144.171 74.3845 144.642 74.5859 145.24C74.7872 145.837 74.8879 146.587 74.8879 147.488C74.8879 148.361 74.8048 149.136 74.6386 149.813C74.4756 150.488 74.2391 151.056 73.9291 151.52C73.6223 151.983 73.2484 152.335 72.8073 152.575C72.3695 152.814 71.8741 152.934 71.3212 152.934C70.7714 152.934 70.2809 152.825 69.8494 152.608C69.4211 152.388 69.0696 152.082 68.7947 151.693C68.523 151.299 68.3489 150.844 68.2722 150.326H69.4419C69.5474 150.777 69.7567 151.149 70.0699 151.443C70.3863 151.734 70.8034 151.879 71.3212 151.879C72.0786 151.879 72.6763 151.549 73.1141 150.887C73.5552 150.226 73.7757 149.291 73.7757 148.083H73.699C73.52 148.351 73.3075 148.583 73.0614 148.778C72.8153 148.973 72.542 149.123 72.2416 149.228C71.9412 149.334 71.6216 149.387 71.2828 149.387C70.7203 149.387 70.2041 149.248 69.7343 148.969C69.2677 148.688 68.8938 148.303 68.6125 147.814C68.3345 147.322 68.1954 146.759 68.1954 146.127C68.1954 145.526 68.3297 144.976 68.5981 144.477C68.8698 143.976 69.2501 143.576 69.7391 143.279C70.2313 142.982 70.8098 142.838 71.4746 142.848ZM71.4746 143.902C71.0719 143.902 70.7091 144.003 70.3863 144.204C70.0667 144.402 69.8126 144.671 69.6241 145.01C69.4387 145.345 69.346 145.718 69.346 146.127C69.346 146.536 69.4355 146.908 69.6145 147.244C69.7967 147.576 70.0443 147.841 70.3576 148.039C70.674 148.234 71.0335 148.332 71.4362 148.332C71.7398 148.332 72.0227 148.273 72.2848 148.155C72.5468 148.033 72.7753 147.868 72.9703 147.661C73.1685 147.45 73.3235 147.212 73.4353 146.946C73.5472 146.678 73.6031 146.398 73.6031 146.107C73.6031 145.724 73.5104 145.364 73.3251 145.029C73.1429 144.693 72.8904 144.422 72.5676 144.214C72.248 144.006 71.8837 143.902 71.4746 143.902Z"
                fill="#757575"
              />
              <rect
                x="50.5498"
                y="161.4"
                width="108"
                height="10.8"
                rx="5.4"
                fill="#E0E4E4"
              />
            </g>
          </g>
          <g filter="url(#filter1_dd_4461_14289)">
            <rect
              x="186.45"
              y="37.2"
              width="126"
              height="144"
              rx="7.2"
              fill="#DFE3E3"
            />
            <g clipPath="url(#clip2_4461_14289)">
              <rect
                x="182.85"
                y="33.6"
                width="126"
                height="144"
                rx="7.2"
                fill="white"
              />
              <path
                d="M182.85 40.8C182.85 36.8235 186.074 33.6 190.05 33.6H301.65C305.627 33.6 308.85 36.8235 308.85 40.8V48H182.85V40.8Z"
                fill="#EFF1F1"
              />
              <circle cx="191.85" cy="40.8" r="1.8" fill="#C9CDCD" />
              <circle cx="199.05" cy="40.8" r="1.8" fill="#C9CDCD" />
              <circle cx="206.25" cy="40.8" r="1.8" fill="#C9CDCD" />
              <rect
                x="191.85"
                y="55.2"
                width="108"
                height="55.8"
                rx="2.7"
                fill="#EFF1F1"
              />
              <rect
                x="240.45"
                y="59.7"
                width="10.8"
                height="12.6"
                rx="1.8"
                fill="#C9CDCD"
              />
              <rect
                x="232.35"
                y="70.5"
                width="27"
                height="34.2"
                rx="3.6"
                fill="#C9CDCD"
              />
              <rect
                x="191.85"
                y="118.2"
                width="61.2"
                height="5.4"
                rx="2.7"
                fill="#C9CDCD"
              />
              <path
                d="M195.824 145.027V132.754H196.611V145.027H195.824ZM198.284 136.561C198.233 136.107 198.022 135.756 197.651 135.506C197.28 135.254 196.814 135.128 196.251 135.128C195.848 135.128 195.5 135.191 195.206 135.319C194.912 135.444 194.683 135.617 194.52 135.837C194.361 136.054 194.281 136.302 194.281 136.58C194.281 136.813 194.335 137.015 194.444 137.184C194.556 137.354 194.701 137.496 194.88 137.611C195.062 137.723 195.257 137.817 195.465 137.894C195.673 137.967 195.872 138.028 196.064 138.076L197.023 138.325C197.336 138.402 197.657 138.506 197.986 138.637C198.316 138.768 198.621 138.94 198.902 139.155C199.183 139.369 199.41 139.634 199.583 139.95C199.759 140.267 199.847 140.645 199.847 141.087C199.847 141.643 199.703 142.136 199.415 142.568C199.131 142.999 198.717 143.34 198.173 143.589C197.633 143.838 196.98 143.963 196.213 143.963C195.478 143.963 194.842 143.846 194.305 143.613C193.768 143.38 193.347 143.049 193.044 142.621C192.74 142.189 192.572 141.678 192.54 141.087H194.027C194.055 141.441 194.17 141.737 194.372 141.973C194.576 142.207 194.837 142.381 195.153 142.496C195.473 142.608 195.823 142.664 196.203 142.664C196.622 142.664 196.994 142.598 197.32 142.467C197.649 142.333 197.908 142.148 198.097 141.911C198.285 141.671 198.38 141.392 198.38 141.072C198.38 140.781 198.296 140.543 198.13 140.358C197.967 140.172 197.745 140.019 197.464 139.898C197.186 139.776 196.871 139.669 196.519 139.576L195.359 139.26C194.573 139.046 193.95 138.731 193.49 138.316C193.033 137.9 192.804 137.35 192.804 136.666C192.804 136.101 192.958 135.607 193.264 135.185C193.571 134.763 193.987 134.436 194.511 134.202C195.035 133.966 195.626 133.848 196.285 133.848C196.949 133.848 197.536 133.964 198.044 134.197C198.555 134.431 198.958 134.752 199.252 135.161C199.546 135.567 199.7 136.034 199.712 136.561H198.284ZM204.901 143.934C204.242 143.934 203.654 143.821 203.136 143.594C202.622 143.367 202.214 143.052 201.914 142.649C201.617 142.243 201.457 141.774 201.435 141.24H202.94C202.959 141.531 203.057 141.783 203.232 141.997C203.411 142.208 203.645 142.371 203.932 142.486C204.22 142.601 204.54 142.659 204.891 142.659C205.278 142.659 205.62 142.592 205.917 142.458C206.217 142.323 206.452 142.136 206.622 141.897C206.791 141.654 206.876 141.374 206.876 141.058C206.876 140.729 206.791 140.439 206.622 140.19C206.456 139.938 206.211 139.739 205.888 139.596C205.569 139.452 205.182 139.38 204.728 139.38H203.899V138.172H204.728C205.092 138.172 205.412 138.106 205.687 137.975C205.965 137.844 206.182 137.662 206.339 137.429C206.495 137.192 206.574 136.916 206.574 136.599C206.574 136.296 206.505 136.032 206.368 135.808C206.233 135.581 206.042 135.404 205.792 135.276C205.546 135.148 205.255 135.084 204.92 135.084C204.6 135.084 204.301 135.143 204.023 135.262C203.748 135.377 203.525 135.543 203.352 135.76C203.18 135.974 203.087 136.232 203.074 136.532H201.641C201.657 136.002 201.813 135.535 202.111 135.132C202.411 134.73 202.807 134.415 203.299 134.188C203.792 133.961 204.338 133.848 204.939 133.848C205.569 133.848 206.112 133.971 206.569 134.217C207.029 134.46 207.384 134.784 207.633 135.19C207.886 135.596 208.01 136.04 208.007 136.523C208.01 137.072 207.857 137.539 207.547 137.922C207.24 138.306 206.831 138.563 206.32 138.694V138.771C206.972 138.87 207.477 139.129 207.835 139.548C208.196 139.966 208.375 140.486 208.372 141.106C208.375 141.646 208.225 142.13 207.921 142.558C207.62 142.987 207.21 143.324 206.689 143.57C206.168 143.813 205.572 143.934 204.901 143.934ZM209.978 141.882V140.684L214.22 133.982H215.165V135.746H214.565L211.531 140.55V140.626H217.346V141.882H209.978ZM214.633 143.8V141.518L214.642 140.971V133.982H216.047V143.8H214.633Z"
                fill="#2962FF"
              />
              <rect
                x="191.85"
                y="152.4"
                width="108"
                height="10.8"
                rx="5.4"
                fill="#E0E4E4"
              />
            </g>
          </g>
          <g filter="url(#filter2_dd_4461_14289)">
            <rect
              x="263.85"
              y="24.6"
              width="57.6"
              height="19.8"
              rx="9.9"
              fill="#D2F1D8"
            />
            <path
              d="M272.85 36.3L277.35 32.7L280.05 34.5L284.55 30.9M284.55 33.6V30.9H281.85"
              stroke="#065F46"
              strokeWidth="1.35"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M292.151 38.2L290.154 31H291.297L292.699 36.5757H292.766L294.225 31H295.357L296.816 36.5792H296.883L298.282 31H299.428L297.428 38.2H296.335L294.819 32.807H294.763L293.248 38.2H292.151ZM300.334 38.2V32.8H301.386V38.2H300.334ZM300.865 31.9667C300.683 31.9667 300.525 31.9058 300.394 31.7839C300.265 31.6597 300.201 31.5121 300.201 31.341C300.201 31.1675 300.265 31.0199 300.394 30.898C300.525 30.7738 300.683 30.7117 300.865 30.7117C301.048 30.7117 301.204 30.7738 301.333 30.898C301.464 31.0199 301.53 31.1675 301.53 31.341C301.53 31.5121 301.464 31.6597 301.333 31.7839C301.204 31.9058 301.048 31.9667 300.865 31.9667ZM303.851 34.9937V38.2H302.8V32.8H303.809V33.6789H303.876C304 33.3929 304.194 33.1632 304.459 32.9898C304.726 32.8164 305.063 32.7296 305.468 32.7296C305.836 32.7296 306.158 32.807 306.435 32.9617C306.712 33.114 306.926 33.3414 307.078 33.6437C307.231 33.946 307.307 34.3199 307.307 34.7652V38.2H306.256V34.8917C306.256 34.5003 306.154 34.1945 305.95 33.9742C305.746 33.7515 305.466 33.6402 305.11 33.6402C304.866 33.6402 304.649 33.6929 304.459 33.7984C304.272 33.9039 304.123 34.0585 304.013 34.2625C303.905 34.464 303.851 34.7078 303.851 34.9937ZM312.763 34.1183L311.81 34.2871C311.771 34.1652 311.707 34.0492 311.621 33.939C311.536 33.8289 311.421 33.7386 311.276 33.6683C311.131 33.598 310.949 33.5628 310.731 33.5628C310.433 33.5628 310.185 33.6296 309.986 33.7632C309.787 33.8945 309.687 34.0644 309.687 34.273C309.687 34.4535 309.754 34.5988 309.887 34.7089C310.021 34.8191 310.237 34.9093 310.534 34.9796L311.392 35.1765C311.889 35.2914 312.259 35.4683 312.503 35.7074C312.747 35.9464 312.869 36.257 312.869 36.639C312.869 36.9625 312.775 37.2507 312.587 37.5039C312.402 37.7546 312.143 37.9515 311.81 38.0945C311.48 38.2375 311.097 38.3089 310.661 38.3089C310.056 38.3089 309.563 38.18 309.181 37.9222C308.799 37.6621 308.564 37.2929 308.478 36.8148L309.494 36.6601C309.557 36.925 309.687 37.1253 309.884 37.2613C310.081 37.3949 310.337 37.4617 310.654 37.4617C310.998 37.4617 311.274 37.3902 311.48 37.2472C311.686 37.1019 311.789 36.925 311.789 36.7164C311.789 36.5476 311.726 36.4058 311.599 36.291C311.475 36.1761 311.284 36.0894 311.026 36.0308L310.112 35.8304C309.608 35.7156 309.236 35.5328 308.994 35.282C308.755 35.0312 308.636 34.7136 308.636 34.3292C308.636 34.0105 308.725 33.7316 308.903 33.4925C309.081 33.2535 309.327 33.0671 309.641 32.9335C309.955 32.7976 310.315 32.7296 310.721 32.7296C311.304 32.7296 311.763 32.8562 312.099 33.1093C312.434 33.3601 312.655 33.6964 312.763 34.1183Z"
              fill="#065F46"
            />
          </g>
          <g filter="url(#filter3_dd_4461_14289)">
            <rect
              x="71.25"
              y="197.4"
              width="66.6"
              height="18"
              rx="9"
              fill="#EAEDED"
            />
            <path
              d="M93.6656 205.15H92.7938C92.7422 204.899 92.652 204.679 92.523 204.489C92.3965 204.299 92.2418 204.14 92.059 204.011C91.8785 203.88 91.6781 203.781 91.4578 203.716C91.2375 203.65 91.0078 203.617 90.7688 203.617C90.3328 203.617 89.9379 203.727 89.584 203.948C89.2324 204.168 88.9523 204.493 88.7438 204.921C88.5375 205.35 88.4344 205.877 88.4344 206.5C88.4344 207.123 88.5375 207.65 88.7438 208.078C88.9523 208.507 89.2324 208.832 89.584 209.052C89.9379 209.273 90.3328 209.383 90.7688 209.383C91.0078 209.383 91.2375 209.35 91.4578 209.284C91.6781 209.219 91.8785 209.121 92.059 208.993C92.2418 208.861 92.3965 208.701 92.523 208.511C92.652 208.319 92.7422 208.098 92.7938 207.85H93.6656C93.6 208.218 93.4805 208.547 93.307 208.838C93.1336 209.128 92.918 209.376 92.6602 209.58C92.4023 209.781 92.1129 209.935 91.7918 210.04C91.473 210.146 91.132 210.198 90.7688 210.198C90.1547 210.198 89.6086 210.048 89.1305 209.748C88.6523 209.448 88.2762 209.022 88.002 208.469C87.7277 207.916 87.5906 207.259 87.5906 206.5C87.5906 205.741 87.7277 205.084 88.002 204.531C88.2762 203.978 88.6523 203.552 89.1305 203.252C89.6086 202.952 90.1547 202.802 90.7688 202.802C91.132 202.802 91.473 202.854 91.7918 202.96C92.1129 203.065 92.4023 203.22 92.6602 203.424C92.918 203.625 93.1336 203.871 93.307 204.162C93.4805 204.45 93.6 204.78 93.6656 205.15ZM97.1558 210.212C96.6683 210.212 96.2405 210.096 95.8726 209.864C95.5069 209.632 95.221 209.308 95.0147 208.891C94.8108 208.473 94.7089 207.986 94.7089 207.428C94.7089 206.866 94.8108 206.375 95.0147 205.955C95.221 205.536 95.5069 205.21 95.8726 204.978C96.2405 204.746 96.6683 204.63 97.1558 204.63C97.6433 204.63 98.0698 204.746 98.4354 204.978C98.8034 205.21 99.0894 205.536 99.2933 205.955C99.4995 206.375 99.6026 206.866 99.6026 207.428C99.6026 207.986 99.4995 208.473 99.2933 208.891C99.0894 209.308 98.8034 209.632 98.4354 209.864C98.0698 210.096 97.6433 210.212 97.1558 210.212ZM97.1558 209.467C97.5261 209.467 97.8308 209.372 98.0698 209.182C98.3089 208.993 98.4858 208.743 98.6007 208.434C98.7155 208.124 98.7729 207.789 98.7729 207.428C98.7729 207.067 98.7155 206.731 98.6007 206.419C98.4858 206.107 98.3089 205.855 98.0698 205.663C97.8308 205.471 97.5261 205.375 97.1558 205.375C96.7854 205.375 96.4808 205.471 96.2417 205.663C96.0026 205.855 95.8257 206.107 95.7108 206.419C95.596 206.731 95.5386 207.067 95.5386 207.428C95.5386 207.789 95.596 208.124 95.7108 208.434C95.8257 208.743 96.0026 208.993 96.2417 209.182C96.4808 209.372 96.7854 209.467 97.1558 209.467ZM101.699 206.852V210.1H100.869V204.7H101.671V205.544H101.741C101.868 205.27 102.06 205.049 102.318 204.883C102.575 204.714 102.908 204.63 103.316 204.63C103.682 204.63 104.002 204.705 104.276 204.855C104.55 205.002 104.763 205.227 104.916 205.53C105.068 205.83 105.144 206.209 105.144 206.669V210.1H104.314V206.725C104.314 206.301 104.204 205.97 103.984 205.734C103.764 205.495 103.461 205.375 103.077 205.375C102.812 205.375 102.575 205.432 102.367 205.547C102.161 205.662 101.998 205.83 101.878 206.05C101.759 206.27 101.699 206.537 101.699 206.852ZM109.009 204.7V205.403H106.21V204.7H109.009ZM107.026 203.406H107.856V208.553C107.856 208.787 107.89 208.963 107.958 209.08C108.028 209.195 108.117 209.273 108.225 209.312C108.335 209.35 108.451 209.369 108.573 209.369C108.664 209.369 108.739 209.364 108.798 209.355C108.856 209.343 108.903 209.334 108.938 209.327L109.107 210.072C109.051 210.093 108.972 210.114 108.872 210.135C108.771 210.159 108.643 210.17 108.488 210.17C108.254 210.17 108.024 210.12 107.799 210.019C107.577 209.918 107.392 209.765 107.244 209.559C107.099 209.352 107.026 209.092 107.026 208.778V203.406ZM110.257 210.1V204.7H111.058V205.516H111.115C111.213 205.248 111.391 205.032 111.649 204.865C111.907 204.699 112.197 204.616 112.521 204.616C112.582 204.616 112.658 204.617 112.749 204.619C112.841 204.621 112.91 204.625 112.957 204.63V205.473C112.929 205.466 112.864 205.456 112.763 205.442C112.665 205.425 112.561 205.417 112.45 205.417C112.188 205.417 111.954 205.472 111.747 205.582C111.543 205.69 111.382 205.84 111.262 206.032C111.145 206.222 111.086 206.439 111.086 206.683V210.1H110.257ZM115.97 210.212C115.482 210.212 115.054 210.096 114.686 209.864C114.321 209.632 114.035 209.308 113.829 208.891C113.625 208.473 113.523 207.986 113.523 207.428C113.523 206.866 113.625 206.375 113.829 205.955C114.035 205.536 114.321 205.21 114.686 204.978C115.054 204.746 115.482 204.63 115.97 204.63C116.457 204.63 116.884 204.746 117.249 204.978C117.617 205.21 117.903 205.536 118.107 205.955C118.313 206.375 118.417 206.866 118.417 207.428C118.417 207.986 118.313 208.473 118.107 208.891C117.903 209.308 117.617 209.632 117.249 209.864C116.884 210.096 116.457 210.212 115.97 210.212ZM115.97 209.467C116.34 209.467 116.645 209.372 116.884 209.182C117.123 208.993 117.3 208.743 117.415 208.434C117.529 208.124 117.587 207.789 117.587 207.428C117.587 207.067 117.529 206.731 117.415 206.419C117.3 206.107 117.123 205.855 116.884 205.663C116.645 205.471 116.34 205.375 115.97 205.375C115.599 205.375 115.295 205.471 115.056 205.663C114.817 205.855 114.64 206.107 114.525 206.419C114.41 206.731 114.352 207.067 114.352 207.428C114.352 207.789 114.41 208.124 114.525 208.434C114.64 208.743 114.817 208.993 115.056 209.182C115.295 209.372 115.599 209.467 115.97 209.467ZM120.513 202.9V210.1H119.683V202.9H120.513Z"
              fill="#757575"
            />
          </g>
          <g filter="url(#filter4_dd_4461_14289)">
            <rect
              x="212.55"
              y="188.4"
              width="66.6"
              height="18"
              rx="9"
              fill="#EAF0FF"
            />
            <path
              d="M230.17 193.9L232.174 199.764H232.255L234.259 193.9H235.433L232.842 201.1H231.587L228.996 193.9H230.17ZM237.428 201.22C237.086 201.22 236.777 201.156 236.5 201.03C236.224 200.901 236.004 200.714 235.843 200.471C235.683 200.227 235.604 199.928 235.604 199.574C235.604 199.27 235.662 199.019 235.779 198.822C235.897 198.625 236.055 198.469 236.254 198.354C236.453 198.239 236.676 198.153 236.922 198.094C237.168 198.036 237.419 197.991 237.674 197.961C237.998 197.923 238.26 197.893 238.462 197.869C238.663 197.843 238.81 197.802 238.901 197.746C238.993 197.69 239.038 197.598 239.038 197.472V197.447C239.038 197.14 238.952 196.902 238.778 196.734C238.607 196.565 238.352 196.48 238.012 196.48C237.658 196.48 237.379 196.559 237.175 196.716C236.974 196.871 236.834 197.043 236.757 197.233L235.769 197.008C235.886 196.68 236.057 196.415 236.282 196.213C236.51 196.009 236.771 195.862 237.066 195.77C237.362 195.677 237.672 195.63 237.998 195.63C238.213 195.63 238.442 195.655 238.683 195.707C238.927 195.756 239.154 195.848 239.365 195.981C239.579 196.115 239.753 196.306 239.889 196.554C240.025 196.8 240.093 197.12 240.093 197.514V201.1H239.067V200.362H239.024C238.956 200.498 238.854 200.631 238.719 200.762C238.583 200.894 238.408 201.003 238.195 201.089C237.981 201.176 237.726 201.22 237.428 201.22ZM237.657 200.376C237.947 200.376 238.196 200.318 238.402 200.203C238.611 200.089 238.769 199.939 238.877 199.753C238.987 199.566 239.042 199.366 239.042 199.152V198.456C239.004 198.494 238.932 198.529 238.824 198.562C238.719 198.592 238.598 198.619 238.462 198.643C238.326 198.664 238.194 198.684 238.065 198.702C237.936 198.719 237.828 198.733 237.741 198.745C237.537 198.77 237.351 198.814 237.182 198.875C237.016 198.936 236.882 199.023 236.781 199.138C236.683 199.251 236.634 199.401 236.634 199.588C236.634 199.848 236.73 200.045 236.922 200.179C237.114 200.31 237.359 200.376 237.657 200.376ZM241.493 201.1V195.7H242.509V196.558H242.566C242.664 196.267 242.837 196.039 243.086 195.872C243.337 195.703 243.62 195.619 243.937 195.619C244.002 195.619 244.08 195.621 244.169 195.626C244.26 195.631 244.332 195.637 244.383 195.644V196.649C244.341 196.637 244.266 196.625 244.158 196.611C244.05 196.594 243.942 196.586 243.835 196.586C243.586 196.586 243.365 196.639 243.17 196.744C242.978 196.847 242.826 196.991 242.713 197.177C242.601 197.359 242.544 197.568 242.544 197.802V201.1H241.493ZM245.293 201.1V195.7H246.344V201.1H245.293ZM245.824 194.867C245.641 194.867 245.484 194.806 245.353 194.684C245.224 194.56 245.159 194.412 245.159 194.241C245.159 194.068 245.224 193.92 245.353 193.798C245.484 193.674 245.641 193.612 245.824 193.612C246.006 193.612 246.162 193.674 246.291 193.798C246.422 193.92 246.488 194.068 246.488 194.241C246.488 194.412 246.422 194.56 246.291 194.684C246.162 194.806 246.006 194.867 245.824 194.867ZM249.33 201.22C248.987 201.22 248.678 201.156 248.401 201.03C248.125 200.901 247.906 200.714 247.744 200.471C247.585 200.227 247.505 199.928 247.505 199.574C247.505 199.27 247.564 199.019 247.681 198.822C247.798 198.625 247.956 198.469 248.155 198.354C248.355 198.239 248.577 198.153 248.823 198.094C249.069 198.036 249.32 197.991 249.576 197.961C249.899 197.923 250.162 197.893 250.363 197.869C250.565 197.843 250.711 197.802 250.803 197.746C250.894 197.69 250.94 197.598 250.94 197.472V197.447C250.94 197.14 250.853 196.902 250.68 196.734C250.508 196.565 250.253 196.48 249.913 196.48C249.559 196.48 249.28 196.559 249.076 196.716C248.875 196.871 248.735 197.043 248.658 197.233L247.67 197.008C247.787 196.68 247.958 196.415 248.183 196.213C248.411 196.009 248.672 195.862 248.967 195.77C249.263 195.677 249.573 195.63 249.899 195.63C250.115 195.63 250.343 195.655 250.585 195.707C250.828 195.756 251.056 195.848 251.267 195.981C251.48 196.115 251.655 196.306 251.791 196.554C251.926 196.8 251.994 197.12 251.994 197.514V201.1H250.968V200.362H250.926C250.858 200.498 250.756 200.631 250.62 200.762C250.484 200.894 250.309 201.003 250.096 201.089C249.883 201.176 249.627 201.22 249.33 201.22ZM249.558 200.376C249.849 200.376 250.097 200.318 250.303 200.203C250.512 200.089 250.67 199.939 250.778 199.753C250.888 199.566 250.943 199.366 250.943 199.152V198.456C250.906 198.494 250.833 198.529 250.725 198.562C250.62 198.592 250.499 198.619 250.363 198.643C250.227 198.664 250.095 198.684 249.966 198.702C249.837 198.719 249.729 198.733 249.642 198.745C249.439 198.77 249.252 198.814 249.083 198.875C248.917 198.936 248.783 199.023 248.683 199.138C248.584 199.251 248.535 199.401 248.535 199.588C248.535 199.848 248.631 200.045 248.823 200.179C249.016 200.31 249.26 200.376 249.558 200.376ZM254.446 197.894V201.1H253.395V195.7H254.404V196.579H254.47C254.595 196.293 254.789 196.063 255.054 195.89C255.321 195.716 255.657 195.63 256.063 195.63C256.431 195.63 256.753 195.707 257.03 195.862C257.306 196.014 257.521 196.241 257.673 196.544C257.825 196.846 257.902 197.22 257.902 197.665V201.1H256.85V197.792C256.85 197.4 256.748 197.095 256.545 196.874C256.341 196.652 256.061 196.54 255.704 196.54C255.461 196.54 255.244 196.593 255.054 196.698C254.866 196.804 254.718 196.959 254.607 197.162C254.5 197.364 254.446 197.608 254.446 197.894ZM261.832 195.7V196.544H258.882V195.7H261.832ZM259.673 194.406H260.725V199.514C260.725 199.718 260.755 199.872 260.816 199.975C260.877 200.076 260.955 200.145 261.052 200.182C261.15 200.218 261.257 200.235 261.371 200.235C261.456 200.235 261.53 200.229 261.593 200.218C261.656 200.206 261.705 200.196 261.741 200.189L261.93 201.058C261.87 201.081 261.783 201.105 261.67 201.128C261.558 201.154 261.417 201.168 261.248 201.17C260.972 201.175 260.714 201.126 260.475 201.023C260.236 200.92 260.043 200.76 259.895 200.545C259.747 200.329 259.673 200.058 259.673 199.732V194.406Z"
              fill="#2962FF"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_dd_4461_14289"
            x="29.5498"
            y="34.6"
            width="153.6"
            height="171.6"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4461_14289"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_4461_14289"
              result="effect2_dropShadow_4461_14289"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_4461_14289"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_dd_4461_14289"
            x="170.85"
            y="25.6"
            width="153.6"
            height="171.6"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4461_14289"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_4461_14289"
              result="effect2_dropShadow_4461_14289"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_4461_14289"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_dd_4461_14289"
            x="251.85"
            y="16.6"
            width="81.6001"
            height="43.8"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4461_14289"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_4461_14289"
              result="effect2_dropShadow_4461_14289"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_4461_14289"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_dd_4461_14289"
            x="59.25"
            y="189.4"
            width="90.6001"
            height="42"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4461_14289"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_4461_14289"
              result="effect2_dropShadow_4461_14289"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_4461_14289"
              result="shape"
            />
          </filter>
          <filter
            id="filter4_dd_4461_14289"
            x="200.55"
            y="180.4"
            width="90.6001"
            height="42"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4461_14289"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_4461_14289"
              result="effect2_dropShadow_4461_14289"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_4461_14289"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_4461_14289">
            <rect width="349" height="237" fill="white" />
          </clipPath>
          <clipPath id="clip1_4461_14289">
            <rect
              x="41.5498"
              y="42.6"
              width="126"
              height="144"
              rx="7.2"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip2_4461_14289">
            <rect
              x="182.85"
              y="33.6"
              width="126"
              height="144"
              rx="7.2"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
